import { render, staticRenderFns } from "./skills.vue?vue&type=template&id=655e7378&scoped=true&"
import script from "./skills.vue?vue&type=script&lang=js&"
export * from "./skills.vue?vue&type=script&lang=js&"
import style0 from "./skills.vue?vue&type=style&index=0&id=655e7378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655e7378",
  null
  
)

export default component.exports